module.exports = __webpack_public_path__ + "media/images/general/arrow_tri_sort-62d08090ed58c4de4cd3c31678f8cd8f.svg";